import { Component, Input } from '@angular/core';

@Component({
  selector: 'l-small-error',
  template: `<small class="form-error-feedback mt-1 block text-[10px] leading-3 font-bold text-danger-500"><ng-content></ng-content></small>`
})
export class SmallErrorComponent {}
